<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-envelope-open-text"></i> Surat Jalan
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                    <button v-if="$can('create surat jalan')" type="button" class="btn btn-primary" @click="addNew">
                        <i class="fas fa-plus-square"></i> Surat Jalan
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/surat-jalans"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="gudang_asal" slot-scope="props">
                            <span v-if="props.rowData.type == 'pindah_gudang'">{{ props.rowData.suratable.gudang_asal.name }}</span>
                            <span v-else-if="props.rowData.type == 're_dry'">{{ props.rowData.suratable.gudang.name }}</span>
                        </template>
                        <template slot="tanggal_keluar" slot-scope="props">
                            <span>{{ props.rowData.suratable ? formatDate(props.rowData.suratable.tanggal_berangkat) : '-' }}</span>
                        </template>
                        <template slot="action" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                            <button v-if="$can('edit surat jalan') || isSuperAdmin" type="button" title="Edit" @click="edit(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button :disabled="isLoading" @click="print(props.rowData.id)" type="button" class="btn btn-link px-1"><i class="fas fa-print"></i></button>
                            <button v-if="isSuperAdmin" type="button" title="Delete" @click="deleteItem(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="md" :hide-header="true" :hide-footer="true">
            <edit-form :isEdit="isEdit" :value="currentSuratJalan" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>

        <b-modal v-model="viewModal" size="md" :hide-header="true" :hide-footer="true">
            <viewer :value="currentSuratJalan" @cancel="viewModal = false"></viewer>
		</b-modal>

        <b-modal v-model="showApproval" size="md" :hide-header="true" :hide-footer="true">
            <viewer is-approval :value="currentSuratJalan" @saved="saved" @cancel="showApproval = false"></viewer>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import EditForm from './Form';
import SearchBar from './SearchBar';
import ExportMixin from '../../mixin/export';
import Viewer from './Viewer';
import Multiselect from 'vue-multiselect';

export default {
    name: "surat-jalan",

    components: {
        EditForm,
        SearchBar,
        Viewer,
        Multiselect,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentSuratJalan: null,
            searchText: '',
            searchDate: '',
            searchType: 'pindah_gudang',
            editModal: false,
            viewModal: false,
            isPreview: false,
            isEdit: false,
            showApproval: false,
            noBatal: false,
            showDeleteModal: false,
            status: {
                name: 'terjual',
                value: 'Terjual',
            },
            statusOptions: [
                {
                    name: 'terjual',
                    value: 'Terjual',
                },
                {
                    name: 'hilang',
                    value: 'Hilang',
                },
                {
                    name: 'rusak',
                    value: 'Rusak',
                },
            ],
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'admin_gudang',
                    title: 'Admin Gudang',
                    sortField: 'admin_gudang',
                },
                {
                    name: 'driver',
                    title: 'Sopir',
                    sortField: 'driver',
                },
                {
                    name: 'vendor',
                    title: 'Vendor',
                    sortField: 'vendor',
                },
                {
                    name: '__slot:gudang_asal',
                    title: 'Gudang Asal',
                },
                {
                    name: 'suratable.bobot_berangkat',
                    title: 'Berat',
                    callback: 'formatNumber',
                },
                {
                    name: '__slot:tanggal_keluar',
                    title: 'Tanggal Keluar',
                },
                {
                    name: '__slot:action',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                type: this.searchType,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchType = search.searchType;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchType = 'pindah_gudang';
            this.refresh();
        },

        addNew() {
            this.isEdit = false;
            this.currentSuratJalan = null;
            this.editModal = true;
        },

        edit(rowData) {
            this.isEdit = true;
            this.currentSuratJalan = Object.assign({}, rowData);
            this.editModal = true;
        },

        view(rowData) {
            this.currentSuratJalan = Object.assign({}, rowData);
            this.viewModal = true;
        },

        saved() {
            this.editModal = false;
            this.isEdit = false;
            this.showApproval = false;
            this.refresh();
        },

        printList() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/surat-jalans/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        print(id) {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/surat-jalans/print/' + id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        deleteItem(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.isLoading = true;
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/surat-jalans/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.isLoading = false;
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
